import lego from 'common/assets/lottie/lego.json';
import { COMPONENT_STATES, COMPONENT_TYPE as TYPE, DEFAULT_MEDIA_QUERY_PLATFORMS } from 'common/constants';
import { generateElementId, generateNodeId } from 'utils/generate-id';
import View from 'client/components/common/BuildingBlocks/Lottie/Lottie';
import { OTHER_PROPS } from 'common/constants/component-props';

export const LOTTIE = () => {
	const _id = generateElementId();

	return {
		view: View,
		model: {
			_id,
			type: TYPE.LOTTIE,
			uiConfig: {
				layer: undefined,
				editorProps: {
					name: LOTTIE.displayName,
					selectable: true,
					draggable: true,
					expandable: false,
					expanded: false,
				},
				nodeProps: {
					id: generateNodeId(_id, LOTTIE.displayName),
				},
				componentProps: {
					styles: {},
					other: {
						[COMPONENT_STATES.DEFAULT]: {
							[DEFAULT_MEDIA_QUERY_PLATFORMS.DEFAULT]: {
								[OTHER_PROPS.lottie.ltSrc]: lego,
							},
						},
					},
				},
			},
			children: [],
		},
	};
};

LOTTIE.displayName = 'Lottie';
